import { render, staticRenderFns } from "./ParticipationsComponent.vue?vue&type=template&id=5edfcec0&scoped=true"
import script from "./ParticipationsComponent.vue?vue&type=script&lang=js"
export * from "./ParticipationsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edfcec0",
  null
  
)

export default component.exports